import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap";
import worker from "../assests/worker.webp";
import { Link, useNavigate } from "react-router-dom";
import logo from "./../assests/logo_1.png";
import emailjs from "@emailjs/browser";
import { init } from "@emailjs/browser";
import Footer from "./Footer";

function ContactUs() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
    attachment: "",
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div>
        <div className="contact-page">
          <div className="overlay"></div>
          <div className="content-wrapper1">
            <h1>Contact Us</h1>
          </div>
        </div>
      </div>
      {/* Add margin top to avoid overlap with the navbar */}
      <Container
        fluid
        className="p-5"
        style={{
          backgroundColor: "#2C3E50",
          color: "white",
          marginTop: "100px",
        }} // Add marginTop
      >
        <Row>
          {/* First Flexbox: Content */}
          <Col md={6}>
            <h2>We&apos;re Here to Help Contact Us</h2>
            <h5 className="text-warning mb-3">Get In Touch</h5>

            <Row className="mb-4">
              <Col md={12} className="mb-3">
                <Card className="bg-dark text-white p-3">
                  <Card.Body className="d-flex align-items-center">
                    <div className="me-3">
                      <i
                        className="bi bi-geo-alt-fill"
                        style={{ fontSize: "1.5rem", color: "#F39C12" }}
                      ></i>
                    </div>
                    <div>
                      <Card.Title>Location</Card.Title>
                      <Card.Text>
                        <span className="fw-bold"> India Address - </span> No.
                        880 , Rajiv Gandhi Nagar, Bangalore 560097,India
                      </Card.Text>
                      <Card.Text>
                        <span className="fw-bold"> USA Address - </span>{" "}
                        15728,Lorain Ave, Unit #170 , Cleveland , OH 44111 , USA
                      </Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={12} className="mb-3">
                <Card className="bg-dark text-white p-3">
                  <Card.Body className="d-flex align-items-center">
                    <div className="me-3">
                      <i
                        className="bi bi-telephone-fill"
                        style={{ fontSize: "1.5rem", color: "#F39C12" }}
                      ></i>
                    </div>
                    <div>
                      <Card.Title>Call Now</Card.Title>
                      <Card.Text>
                        <span className="fw-bold"> India:</span>(+91) 8951960110
                       
                      </Card.Text>
                      <Card.Text>
                        <span className="fw-bold"> USA:</span>
                        +1 216 800-7148
                      </Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={12} className="mb-3">
                <Card className="bg-dark text-white p-3">
                  <Card.Body className="d-flex align-items-center">
                    <div className="me-3">
                      <i
                        className="bi bi-envelope-fill"
                        style={{ fontSize: "1.5rem", color: "#F39C12" }}
                      ></i>
                    </div>
                    <div>
                      <Card.Title>Email</Card.Title>
                      <Card.Text>sales@preciseaxis.com</Card.Text>
                      <Card.Text>preciseaxis@gmail.com</Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>

          {/* Second Flexbox: Image */}
          <Col
            md={6}
            className="d-flex align-items-center justify-content-center"
          >
            {/* <Form className="p-4 shadow-sm rounded">
              <Row>
                <h1 className="text-center mb-">Enquiry Form</h1>
                <Col md={6} className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Your Name"
                    required
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Your Email"
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Your Phone Number"
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Your Message"
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    as="file"
                    rows={4}
                    placeholder="attachment"
                    required
                  />
                </Col>
                <Col md={12}>
                  <Button variant="dark" className="w-100">
                    Submit Enquiry
                  </Button>
                </Col>
              </Row>
            </Form> */}

            <Form
              ref={formData}
              onSubmit={handleSubmit}
              className="p-4 shadow-sm rounded"
            >
              <Row
                style={{
                  backgroundColor: "white",
                  padding: "15px",
                  borderRadius: "10px",
                }}
              >
                <h1 className="text-center mb-4 text-black">Enquiry Form</h1>
                <Col md={6} className="mb-3">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    type="number"
                    name="number"
                    placeholder="Your Phone Number"
                    value={formData.number}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    as="textarea"
                    name="message"
                    rows={4}
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    type="file"
                    name="attachment"
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={12}>
                  <Button variant="dark" type="submit" className="w-100">
                    Submit Enquiry
                  </Button>
                </Col>
              </Row>
            </Form>

            {/* </Col> */}
          </Col>
        </Row>
      </Container>
      {/* Enquiry Form Section */}
      <div style={{ paddingBottom: "60px" }}></div>
      {/* Add some padding or margin between the contact section and footer */}
      <div style={{ paddingBottom: "60px" }}></div>{" "}
      {/* Adds space before the footer */}
     <Footer />
    </div>
  );
}

export default ContactUs;
